/**
 * Contact information constants
 */

export const CONTACT = {
  PHONE_NUMBER: '5511918362857',
  WHATSAPP_BASE_URL: 'https://wa.me',
  EMAIL: 'contato@autoclipper.live',
} as const;

/**
 * Generate a WhatsApp URL with optional pre-filled message
 */
export const createWhatsAppUrl = (message?: string) => {
  const url = `${CONTACT.WHATSAPP_BASE_URL}/${CONTACT.PHONE_NUMBER}`;
  if (message) {
    return `${url}?text=${encodeURIComponent(message)}`;
  }
  return url;
};
